import { ThemeOptions } from '@mui/material/styles';

import { DefaultTheme } from './DefaultTheme';
import Config from '../config';

export const DarkTheme: ThemeOptions = {
    ...DefaultTheme,
    palette: {
        ...DefaultTheme.palette,
        mode: 'dark',
        primary: {
            main: Config.GLOBAL_PRIMARY_COLOR,
        },
        secondary: {
            main: Config.GLOBAL_PRIMARY_COLOR,
        },
        background: {
            default: '#121212',
            paper: '#1e1e1e',
        },
    },
    typography: {
        ...DefaultTheme.typography,
        allVariants: {
            color: '#fff',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                contained: {
                    color: '#fff',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    color: '#fff',
                    '&.Mui-selected': {
                        color: Config.GLOBAL_PRIMARY_COLOR,
                        backgroundColor: 'rgba(66, 165, 245, 0.16)',
                    },
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                thumb: {
                    color: '#424242',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: '#edefff50',
                    color: '#ffffffd4',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: '#2A2A2A',
                },
            },
        },
    },
};
